const startupMainWrap = () => import("@/views/main_wrap.vue");

const createStartupViewRoute = ({ path, name, component, aliases = [], meta = {} }) => ({
    path,
    name,
    alias: aliases,
    meta,
    component: startupMainWrap,
    children: [
        {
            path: "",
            component
        }
    ]
});

export const startupRoutes = [
    createStartupViewRoute({
        path: "/startup/overview",
        name: "GsrstSmain",
        aliases: ["/gsrst_smain", "/startup/gsrst_smain"],
        component: () => import("@/views/startup/gsrst_smain.vue")
    }),
    createStartupViewRoute({
        path: "/startup/gs-the-fresh-franchise",
        name: "Gsrst01010101",
        aliases: [
            "/gsrst01010101",
            "/gsrst01010102",
            "/gsrst01010103",
            "/gsrst01010104",
            "/gsrst010102",
            "/gsrst010103",
            "/gsrst010104",
            "/gsrst0102",
            "/gsrst010201",
            "/gsrst0104",
            "/gsrst0105",
            "/startup/gsrst01010101",
            "/startup/gsrst01010102",
            "/startup/gsrst01010103",
            "/startup/gsrst01010104",
            "/startup/gsrst010102",
            "/startup/gsrst010103",
            "/startup/gsrst010104",
            "/startup/gsrst0102",
            "/startup/gsrst010201",
            "/startup/gsrst0104",
            "/startup/gsrst0105"
        ],
        meta: {
            queryRules: {
                tab: { pattern: /^[a-z0-9-]+$/ },
                subTab: { pattern: /^[a-z0-9-]+$/ }
            }
        },
        component: () => import("@/views/startup/01/gsrst01010101.vue")
    }),
    createStartupViewRoute({
        path: "/startup/gs25-franchise",
        name: "Gsrst02010101",
        aliases: [
            "/gsrst02010101",
            "/startup/gsrst02010101"
        ],
        meta: {
            queryRules: {
                tab: { pattern: /^[a-z0-9-]+$/ },
                subTab: { pattern: /^[a-z0-9-]+$/ }
            }
        },
        component: () => import("@/views/startup/02/gsrst02010101.vue")
    })
];
